// @flow

import React from 'react';
import styled from 'styled-components';
import type { FieldProps } from 'redux-form';
import Error from './error';
import type { Theme } from '../../../types';

type Props = FieldProps & {
  className?: string,
  multiFields?: Array<string>,
};

const StyledError = styled<typeof Error, Theme>(Error)`
  border-radius: 4px 4px 4px 4px;
  margin-top: 0.5rem;
`;

export default ({
  className = '',
  meta,
  multiFields,
}: Props) => {
  let showError = meta.touched;

  if (Array.isArray(multiFields)) {
    // Only show error if all nested fields have been touched
    showError = multiFields.every(field => meta[field] && meta[field].touched);
  }

  return (
    <div className={className}>
      {showError && meta.error && (<StyledError message={meta.error} />)}
    </div>
  );
};
